import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Industries from "../components/Industries";
import Products from "../components/Products";
import CustomSolutions from "../components/CustomSolutions";
import WhyUs from "../components/WhyUs";
import Contact from "../components/Contact";
import FloatingButtons from "../components/FloatingButtons";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="bg-[#050505] min-h-screen">
      <Navbar />
      <Hero />
      <Industries />
      <Products />
      <CustomSolutions />
      <WhyUs />
      <Contact />
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Home;
